import DescriptionIcon from '@mui/icons-material/Description';
import GavelIcon from '@mui/icons-material/Gavel';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PaymentsIcon from '@mui/icons-material/Payments';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import WorkIcon from '@mui/icons-material/Work';
import GroupsIcon from '@mui/icons-material/Groups';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import CampaignIcon from '@mui/icons-material/Campaign';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EventIcon from '@mui/icons-material/Event';
import NewspaperIcon from '@mui/icons-material/Newspaper';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import SchoolIcon from '@mui/icons-material/School';
import PhoneIcon from '@mui/icons-material/Phone';
import PlaceIcon from '@mui/icons-material/Place';
import LinkIcon from '@mui/icons-material/Link';
import { SvgIconComponent } from '@mui/icons-material';

// Pré-visualização das chaves de ACESSO_RAPIDO_ICONS (model/apm/apm-enums.ts)
export const ACESSO_RAPIDO_ICON_COMPONENTS: Record<string, SvgIconComponent> = {
    description: DescriptionIcon,
    gavel: GavelIcon,
    account_balance: AccountBalanceIcon,
    payments: PaymentsIcon,
    receipt_long: ReceiptLongIcon,
    shopping_cart: ShoppingCartIcon,
    work: WorkIcon,
    groups: GroupsIcon,
    support_agent: SupportAgentIcon,
    campaign: CampaignIcon,
    visibility: VisibilityIcon,
    event: EventIcon,
    newspaper: NewspaperIcon,
    menu_book: MenuBookIcon,
    health_and_safety: HealthAndSafetyIcon,
    school: SchoolIcon,
    phone: PhoneIcon,
    place: PlaceIcon,
    link: LinkIcon,
};

export function AcessoRapidoIcon({ name, fontSize = 'small' }: { name?: string; fontSize?: 'small' | 'medium' | 'inherit' }) {
    const Icon = (name && ACESSO_RAPIDO_ICON_COMPONENTS[name]) || LinkIcon;
    return <Icon fontSize={fontSize} />;
}
